import { render, staticRenderFns } from "./Challenge9.vue?vue&type=template&id=d1c84cf0&scoped=true&lang=pug&"
import script from "./Challenge9.vue?vue&type=script&lang=ts&"
export * from "./Challenge9.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1c84cf0",
  null
  
)

export default component.exports